import React, { useState } from 'react';
import './TreeNode.css';

const TreeNode = ({ node, isExpanded, onToggle, level, searchTerm, expandedNodes }) => {
  const [showRedirects, setShowRedirects] = useState(false);
  
  const hasChildren = node.children && node.children.length > 0;
  const indent = level * 20;

  const handleToggle = () => {
    onToggle(node.path);
  };

  const handleRedirectToggle = (e) => {
    e.stopPropagation();
    setShowRedirects(!showRedirects);
  };

  const highlightMatch = (text, searchTerm) => {
    if (!searchTerm) return text;
    
    const regex = new RegExp(`(${searchTerm})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? (
        <span key={index} className="highlight">{part}</span>
      ) : part
    );
  };

  const getStatusColor = (status) => {
    switch (status) {
      case '301': return '#28a745'; // green
      case '302': return '#ffc107'; // yellow
      case '404': return '#dc3545'; // red
      default: return '#6c757d'; // gray
    }
  };

  return (
    <div className="tree-node">
      <div 
        className={`node-header level-${level}`}
        style={{ paddingLeft: `${indent}px` }}
        onClick={handleToggle}
      >
        <div className="node-content">
          <div className="node-info">
            {hasChildren && (
              <span className={`expand-icon ${isExpanded ? 'expanded' : ''}`}>
                ▶
              </span>
            )}
            <span className="node-name">
              {highlightMatch(node.name, searchTerm)}
            </span>
            <span className="node-path">
              {node.path}
            </span>
          </div>
          
          <div className="node-stats">
            <span className="redirect-count" title={`${node.count} redirects at this level`}>
              {node.count}
            </span>
            {node.redirects.length > 0 && (
              <button 
                className="view-redirects-btn"
                onClick={handleRedirectToggle}
                title="View redirects"
              >
                {showRedirects ? '👁️' : '👁️‍🗨️'}
              </button>
            )}
          </div>
        </div>
      </div>

      {showRedirects && (
        <div className="redirects-list" style={{ paddingLeft: `${indent + 40}px` }}>
          <div className="redirects-header">
            <strong>Redirects ({node.redirects.length}):</strong>
          </div>
          {node.redirects.slice(0, 10).map((redirect, index) => (
            <div key={index} className="redirect-item">
              <div className="redirect-source">
                <strong>From:</strong> {redirect.source}
              </div>
              <div className="redirect-target">
                <strong>To:</strong> {redirect.target}
              </div>
              <div className="redirect-status">
                <span 
                  className="status-badge"
                  style={{ backgroundColor: getStatusColor(redirect.status) }}
                >
                  {redirect.status}
                </span>
              </div>
            </div>
          ))}
          {node.redirects.length > 10 && (
            <div className="more-redirects">
              ... and {node.redirects.length - 10} more
            </div>
          )}
        </div>
      )}

      {isExpanded && hasChildren && (
        <div className="children">
          {node.children.map((child) => (
            <TreeNode
              key={child.path}
              node={child}
              isExpanded={expandedNodes.has(child.path)}
              onToggle={onToggle}
              level={level + 1}
              searchTerm={searchTerm}
              expandedNodes={expandedNodes}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TreeNode; 